module.exports = __webpack_public_path__ + "static/img/tuijian.503ade4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tuijian.png
// module id = 8P+z
// module chunks = 1